import { useEffect, useState } from 'react';
import styles from '../../../styles/AppliedFiltersStyle.module.css';

const AppliedFiltersContainer = ({ children }) => {
    return (
        <div className={styles['applied-container-wrapper']}>
            <div style={{minWidth:"max-content"}}>
                <div style={{ padding: '5px 7px 1px' }}>{children}</div>
            </div>
        </div>
    );
};

export default AppliedFiltersContainer;